var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "copy_right" }, [_vm._v(_vm._s(_vm.copyRight))]),
    _vm._v(" "),
    _c("div", { staticClass: "copy_right" }, [
      _vm._v(_vm._s(_vm.devCompany) + "提供技术支持"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }